import { render, staticRenderFns } from "./CompetitorAnalysis.vue?vue&type=template&id=052ed174&scoped=true&"
import script from "./CompetitorAnalysis.vue?vue&type=script&lang=ts&"
export * from "./CompetitorAnalysis.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052ed174",
  null
  
)

export default component.exports